function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.4964 5.1602C13.0581 6.01316 13.339 6.95972 13.339 7.99992C13.339 9.45619 12.8137 10.7096 11.7631 11.7602C10.7125 12.8108 9.45907 13.3361 8.0028 13.3361L7.99996 14.6666L5.35031 12.6496L7.99996 10.6666L8.0028 11.9942C9.1054 11.9942 10.0468 11.6042 10.8269 10.824C11.6071 10.0439 11.9971 9.10252 11.9971 7.99992C11.9971 7.3758 11.8411 6.7517 11.529 6.12758L12.4964 5.1602ZM8.0028 4.00559C6.90019 4.00559 5.95883 4.39566 5.17868 5.17581C4.39854 5.95595 4.00847 6.89731 4.00847 7.99992C4.00847 8.68645 4.1645 9.31055 4.47656 9.87226L3.50918 10.8396C2.94747 9.98668 2.66663 9.04011 2.66663 7.99992C2.66663 6.54365 3.19192 5.29023 4.24251 4.23963C5.29311 3.18904 6.54652 2.66375 8.0028 2.66375L7.99996 1.33325L10.6553 3.35027L7.99996 5.33325L8.0028 4.00559Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));

var SvgIcoRecycle = function SvgIcoRecycle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoRecycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-recycle.edf62f31.svg";
export { ForwardRef as ReactComponent };